module.exports = __webpack_public_path__ + "static/img/case0.f9bd5289.png";